import { Box, Grid, Skeleton } from '@mui/material'

interface Props {
  count?: number
}

export const BlogPostsSkeleton = ({ count = 7 }: Props) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
      }}
    >
      {/* Skeleton cho bài viết lớn đầu tiên */}
      <Grid
        sx={{
          gridRow: 'span 2',
          gridColumn: { xs: 'span 12', lg: 'span 6' },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            sx={{ borderRadius: 2, aspectRatio: '4/3', height: 'auto' }}
          />
          <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
          <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
          <Skeleton variant="text" sx={{ fontSize: '1rem' }} width="60%" />
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Skeleton variant="text" width={60} />
            <Skeleton variant="text" width={80} />
          </Box>
        </Box>
      </Grid>

      {/* Skeleton cho các bài viết còn lại */}
      {Array.from({ length: count - 1 }).map((_, index) => (
        <Grid
          key={index}
          sx={{
            gridColumn: {
              xs: 'span 12',
              sm: 'span 6',
              md: 'span 3',
              xl: 'span 2',
            },
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
            <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '0.9rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '0.9rem' }} width="40%" />
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Skeleton variant="text" width={50} />
              <Skeleton variant="text" width={70} />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
